export default "__VITE_ASSET__Bwj$xFCo__"